module.exports = __webpack_public_path__ + "img/46.97e0ed9f.jpg";